<template>
	<div
		class="toast-wrapper display-flex flex-column"
		aria-live="polite"
		ref="toastWrapper"
		:class="position"
	>
		<transition-group name="slide" tag="div">
			<toast-card
				v-for="toast in toasts"
				:key="toast.id"
				class="toast-single"
				:title="toast.options.title"
				:message="toast.options.message"
				:description="toast.options.description"
				:timeout="toast.options.timeout"
				:timeleft="toast.timeleft"
				:type="toast.options.type"
				:icon="toast.options.icon"
				:actions="toast.options.actions"
				@closeToast="$event => removeToastById(toast.id, $event)"
				v-hammer:swipe.left="$event => removeToastById(toast.id, $event)"
				@mouseenter="paused = true"
				@mouseleave="paused = false"
			/>
			<!-- <div v-for="toast in toasts" :key="toast.id" :class="classes(toast.options.type)" class="toast">
                {{toast.options.message}}
                <div class="timeout" :style="`width: ${toast.timeleft/toast.options.timeout*100}%`"></div>
            </div> -->
		</transition-group>
	</div>
</template>

<script>
import Vue from 'vue';
import ToastCard from './ToastCard';
import { VueHammer } from 'vue2-hammer';
Vue.use(VueHammer);
/**
Toast notification object:
{
    id: unique identifier,
    title: text,
    message: text,
    icon: bossabox dls icon name,
    type: success, danger, warning, normal (default)
    actions: [
        {
            text: action text,
            callback: function to call on click/enter
        }
    ]
}
 */

const EventBus = new Vue();

export const install = {
	install: Vue => {
		Object.defineProperties(Vue.prototype, {
			$toasts: {
				get() {
					return {
						show(options) {
							EventBus.$emit('showToast', options);
						}
					};
				}
			}
		});
	}
};

export default {
	name: 'app-toast',
	components: {
		ToastCard
	},
	data() {
		return {
			toasts: [],
			paused: false
		};
	},
	props: {
		position: {
			type: String,
			default: 'bottom-left'
		}
	},
	methods: {
		removeToastById(id, event) {
			this.toasts = this.toasts.filter(curr => curr.id !== id);
			const wrapper = event.target.closest('.toast-wrapper');
			setTimeout(() => {
				if (!wrapper.querySelector('.toast:hover')) this.paused = false;
			}, 320);
		}
	},
	created() {
		EventBus.$on('showToast', options => {
			const id = new Date().getTime();
			if (typeof options.timeout === 'undefined') options.timeout = 6000;
			const toast = { id, options, timeleft: options.timeout };
			if (options.timeout !== false) {
				toast.interval = setInterval(() => {
					if (!this.paused) toast.timeleft -= 30;
					if (toast.timeleft <= 0) {
						this.toasts = this.toasts.filter(curr => curr.id !== id);
						//this.$forceUpdate();
						clearInterval(toast.interval);
					}
				}, 30);
			}
			this.toasts.push(toast);
			//this.$forceUpdate();
		});
	},
	mounted() {
		// this.$refs.toastWrapper.addEventListener('mouseenter', () => {this.paused = true});
		// this.$refs.toastWrapper.addEventListener('mouseleave', () => {this.paused = false});
		// this.$refs.toastWrapper.addEventListener('focusin', () => {this.paused = true});
		// this.$refs.toastWrapper.addEventListener('focusout', () => {this.paused = false});
		// this.$refs.toastWrapper.addEventListener('touchstart', () => {this.paused = true});
		// this.$refs.toastWrapper.addEventListener('touchend', () => {this.paused = false});
	}
};
</script>

<style lang="scss" scoped>
.toast-single {
	transition: all 0.3s;
	opacity: 1;
	position: relative;
}
.slide-enter,
.slide-leave-to {
	opacity: 0;
	transform: translateX(-50%);
}
.toast-wrapper {
	position: fixed;
	z-index: 9999;
	&.bottom-left {
		bottom: 3.2rem;
		left: 3.2rem;
		@media (max-width: 767px) {
			bottom: 1.6rem;
			left: 1.6rem;
		}
	}
	&.bottom-right {
		bottom: 3.2rem;
		right: 3.2rem;
		@media (max-width: 767px) {
			bottom: 1.6rem;
			right: 1.6rem;
		}
	}
}
</style>
